import { useRef, useState } from "react";
import { fileSrc } from "@/lib/api";

export const BeforeAfterSlider = ({ before, after, height = 360 }) => {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const move = (clientX) => {
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    setPos(Math.max(0, Math.min(100, ((clientX - r.left) / r.width) * 100)));
  };
  if (!before || !after) return null;
  return (
    <div ref={ref} data-testid="before-after-slider" className="relative w-full overflow-hidden rounded-xl select-none bg-slate-900" style={{ height }}
      onMouseMove={(e) => e.buttons === 1 && move(e.clientX)}
      onClick={(e) => move(e.clientX)}
      onTouchMove={(e) => move(e.touches[0].clientX)}>
      <img src={fileSrc(after.url || after.path || after)} alt="après" className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      <div className="absolute inset-0 h-full overflow-hidden" style={{ width: `${pos}%` }}>
        <img src={fileSrc(before.url || before.path || before)} alt="avant" className="absolute inset-0 h-full object-cover" style={{ width: ref.current?.offsetWidth || "100%", maxWidth: "none" }} draggable={false} />
        <span className="absolute top-2 left-2 text-[10px] font-bold uppercase bg-black/60 text-white px-2 py-0.5 rounded">Avant</span>
      </div>
      <span className="absolute top-2 right-2 text-[10px] font-bold uppercase bg-black/60 text-white px-2 py-0.5 rounded">Après</span>
      <div className="absolute top-0 bottom-0 w-0.5 bg-white shadow-lg" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-8 h-8 rounded-full bg-white border-2 border-emerald-500 flex items-center justify-center text-emerald-600 text-xs">⇄</div>
      </div>
    </div>
  );
};
